import styled from "styled-components";
export const MergeUnitsQueueContainer = styled.div.withConfig({
  displayName: "merge-units-queuestyles__MergeUnitsQueueContainer",
  componentId: "sc-b26ln8-0"
})([""]);
export const MergeUnitsQueueHeader = styled.div.withConfig({
  displayName: "merge-units-queuestyles__MergeUnitsQueueHeader",
  componentId: "sc-b26ln8-1"
})(["", ""], {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  marginBottom: "1rem",
  paddingLeft: "0.5rem",
  paddingRight: "0.5rem"
});
export const MergeUnitsQueueActions = styled.div.withConfig({
  displayName: "merge-units-queuestyles__MergeUnitsQueueActions",
  componentId: "sc-b26ln8-2"
})(["", " & >:last-child{", "}"], {
  display: "flex",
  alignItems: "center"
}, {
  marginLeft: "1.5rem"
});
